import PhoneArea from "components/PhonePreview/PhoneArea"
import React from "react"

const Preview = ({
  menu_bg_color,
  menu_font_color,
  booking_type = "",
  label = "",
  bookings = [],
}) => {
  return (
    <PhoneArea>
      <div
        style={{
          backgroundColor: "white",
          width: "105%",
          height: "105%",
          backgroundSize: "cover",
          marginLeft: "-5px",
          backgroundPosition: "center center",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "100px",
            backgroundColor: menu_bg_color,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <i
            className="bx bx-sm bx-x py-1 px-1"
            style={{ cursor: "pointer", color: menu_font_color }}
          />
          <p
            style={{
              textAlign: "center",
              paddingBlockStart: "1em",
              color: menu_font_color,
            }}
          >
            {label}
          </p>
        </div>
        {booking_type === "booking_service" && (
          <>
            <div className="my-2" style={{ textAlign: "center" }}>
              Select a booking type
            </div>
            {bookings.map(booking => (
              <div
                key={booking?.id}
                style={{
                  width: "90%",
                  height: "70px",
                  borderTop: `5px solid ${booking?.calendar?.color}`,
                  backgroundColor: booking?.calendar?.header_bg_color,
                  margin: "5px",
                  marginLeft: "7px",
                  textAlign: "center",
                }}
              >
                <p
                  style={{
                    color: booking?.calendar?.header_font_color,
                    margin: "0px",
                    marginTop: "3px",
                  }}
                >
                  {booking?.calendar?.name}
                </p>
                <p
                  style={{
                    color: booking?.calendar?.header_font_color,
                    margin: "0px",
                  }}
                >
                  {booking?.name}
                </p>
                <p
                  style={{
                    color: booking?.calendar?.header_font_color,
                    margin: "0px",
                  }}
                >
                  {booking?.duration_time < 60 &&
                    booking?.duration_time + " minutes"}
                  {booking?.duration_time >= 60 &&
                    booking?.duration_time / 60 + " hour"}
                </p>
              </div>
            ))}
          </>
        )}
        {booking_type === "view_bookings" && (
          <>
            <div
              className="my-2"
              style={{
                margin: "0 auto",
                backgroundColor: "DimGray",
                width: "70%",
                color: "white",
                textAlign: "center",
              }}
            >
              <span>All calendars </span>
              <i className="bx bx-caret-down" />
            </div>
            <div
              className="my-2"
              style={{
                margin: "0 auto",
                backgroundColor: "DimGray",
                width: "50%",
                color: "white",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <i
                className="bx bx-chevron-left"
                style={{ alignSelf: "center" }}
              />
              <span>June 2020</span>
              <i
                className="bx bx-chevron-right"
                style={{ alignSelf: "center" }}
              />
            </div>
            {Array.from(Array(2).keys()).map((x, index) => (
              <div key={index}>
                <p
                  style={{
                    backgroundColor: "black",
                    width: "fit-content",
                    color: "white",
                    padding: "1px",
                    marginLeft: "5px",
                  }}
                >
                  Date {index + 1}
                </p>
                <div
                  style={{
                    width: "90%",
                    height: "80px",
                    borderTop: `5px solid rgb(41, 223, 223)`,
                    borderRadius: "5px",
                    backgroundColor: "rgb(51, 72, 48)",
                    margin: "5px",
                    marginLeft: "7px",
                    padding: "3px",
                  }}
                >
                  <p
                    style={{
                      color: "rgb(41, 223, 223)",
                      margin: "1px",
                      fontSize: "10px",
                    }}
                  >
                    Calendar Name
                  </p>
                  <p
                    style={{
                      color: "rgb(41, 223, 223)",
                      margin: "1px",
                      fontSize: "14px",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    Booking Type with User
                    <i
                      className="bx bx-chevron-right font-size-16"
                      style={{ alignSelf: "center" }}
                    />
                  </p>
                  <p
                    style={{
                      color: "rgb(41, 223, 223)",
                      margin: "1px",
                      fontSize: "10px",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>Duration</span>
                    <span>start hour</span>
                  </p>
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    </PhoneArea>
  )
}

export default Preview
